<template>
  <div :class="['Menu', singlePage ? 'single-page' : '']" id="menu" ref="menuRef">
    <template v-if="menuShowAll">
      <div class="menu-l">
        <el-input placeholder="菜单筛选.." clearable v-model="filterText" class="menuSearch">
        </el-input>
        <el-scrollbar>
          <!-- <el-scrollbar style="height:100%"> -->
          <customMenu :isFilter="isFilter" :fPaths="fPaths" :menuItems="menuItems" :adminMeunItems="adminMeunItems"
            :defaultPath="defaultPath" @changeAniState="changeAniState" />
        </el-scrollbar>
      </div>
      <div class='menu-r'>
        <!-- <div class="menu-r" ref="menuR" @animationend='inAnimation=false' :style="{animation: inAnimation?animationType:''}"> -->
        <div ref="menuTop" v-if="showBackButton" class="menu-r-top"><span @click="handleClickBack"><i
              class="el-icon-back" style="font-size: 18px;"></i>
            返回</span></div>
        <div class="scrollbar" style="position: relative;">
          <!-- 全局keepalive -->
          <!-- <keep-alive>
          <router-view></router-view>
        </keep-alive> -->

          <!-- 局部keepalive -->
          <!-- <keep-alive>
            <router-view v-if="$route.meta.keepAlive">
            </router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive">
          </router-view> -->
          <transition name="aside-right" appear @after-enter="onPageEnterComplete">
            <router-view>
            </router-view>
          </transition>
        </div>
        <el-button v-if="isScreen" type="primary" @click="openNotice(true)"
          style="position: fixed;left: 12px;bottom: 56px;z-index: 999;" circle> <i class="el-icon-data-analysis"
            style="font-size: 22px;"></i></el-button>
      </div>
    </template>
    <div v-else style="width:100%;position: relative;">
      <transition name="aside-right" appear @after-enter="onPageEnterComplete">
        <router-view>
        </router-view>
      </transition>
    </div>
    <el-drawer title="菜单" :visible.sync="menuDtawer" direction="ltr" size="100%">
      <el-input placeholder="菜单筛选.." clearable v-model="filterText" class="menuSearch">
      </el-input>
      <customMenu :isFilter="isFilter" :fPaths="fPaths" :menuItems="menuItems" :adminMeunItems="adminMeunItems"
        :defaultPath="defaultPath" @changeAniState="changeAniState" />
    </el-drawer>
    <el-backtop target=".scrollbar" :right="8" :bottom="20"></el-backtop>
  </div>
</template>

<script>
// @ is an alias to /src
// import Header from './Header.vue';
import elementResizeDetectorMaker from 'element-resize-detector';
import customMenu from '@/components/customMenu';


export default {
  name: 'Home',
  data() {
    return {
      menuItems: [],
      adminMeunItems: [],
      subs: [],
      items: [],
      menuWidth: 0,
      isCollapse: true,
      filterText: '',
      allPaths: [],
      fPaths: [],
      isFilter: false,
      menuDtawer: false,
      defaultPath: '',
      inAnimation: false,
      animationType: 'animtion1',
      location: window.location,
      notification: null
    };
  },
  components: {
    // Header
    customMenu
  },
  computed: {
    menuShowAll() {
      //问卷为iframe时使用
      // return  this.$store.state.userInfo && this.$store.state.userInfo.usertype == 4 ||this.$store.state.currentModule != 'dcwj'
      return this.$store.state.userInfo && this.$store.state.userInfo.usertype == 4 || this.$store.state.currentModule
    },
    isScreen() {
      return this.$store.state.userInfo && this.$store.state.userInfo.schoolid == 1 && this.$store.state.userInfo.usertype != 4 && window.innerWidth > 1000
    },
    showBackButton() {
      return this.$route.path !== '/h5HomePage' && this.$route.query.back !== 'no';
    },
    singlePage() {
      return this.$store.state.singlePageMenu.includes(this.$route.path)
    }
  },
  created() {
    this.menuItems = this.$store.state.menu;
    // console.log(this.menuItems);
    this.adminMeunItems = this.$store.state.adminMeunItems;
    this.getPaths(this.menuItems);
    this.setDefaultPath(this.$route.path);
    // this.changeAniState();
  },
  watch: {
    '$store.state.menu': {
      handler: function (val) {
        this.menuItems = val;
        this.allPaths = [];
        this.getPaths(this.menuItems);
      },
      deep: false,
    },
    '$route.path': {
      handler: function (val) {
        if (window.innerWidth < 1000) {
          if (val == '/h5HomePage') {
            document.querySelector('.Menu').style.height = 'calc(100% - 70px)'
          } else {
            document.querySelector('.Menu').style.height = '100%'
          }
          window.$notify.close()
        }
        this.setDefaultPath(val);
      },
      deep: false,
    },
    filterText(val) {
      if (val) {
        this.isFilter = true;
        this.fPaths = this.filterPaths(val);
      } else {
        this.isFilter = false;
      }
    },
  },
  mounted() {
    window.handleWindowOpen = (path) => {
      if (this.$store.state.userInfo && this.$store.state.userInfo.schoolid == 1) {
        window.open(`${location.origin}/#${path}`)
      } else {
        this.$message.info('功能暂未开放！')
      }
    };
    if (this.isScreen) {
      if (!this.notification) {
        this.openNotice(false)
      }
    }
    if (this.$route.path == '/h5HomePage' && window.innerWidth < 1000) {
      document.querySelector('.Menu').style.height = 'calc(100% - 70px)'
    }
    this.fPaths = this.$until.easyDeepCopy(this.allPaths);
    if (this.$refs.menuRef.clientWidth == 1280) {
      this.isCollapse = true;
    } else {
      this.isCollapse = false;
    }
    const _this = this;
    const erd = elementResizeDetectorMaker();
    erd.listenTo(document.getElementById('menu'), (element) => {
      _this.$nextTick(() => {
        if (_this.$refs.menuRef.clientWidth == 1280) {
          _this.isCollapse = true;
        } else {
          _this.isCollapse = false;
        }
      });
    });
    if (this.$store.state.userInfo) {
      this.getNewMessages();
    }
  },
  beforeDestroy() {
    // 组件销毁时清理全局函数（可选，避免内存泄漏）
    this.notification ? this.notification.close() : ''
    delete window.handleWindowOpen;
  },
  methods: {
    openNotice(open) {
      if (open || !localStorage.getItem("closeScreen")) {
        this.notification = this.$notify({
          title: '数据大屏',
          dangerouslyUseHTMLString: true,
          message: `<div style="padding:8px 0;cursor:pointer;" onclick="handleWindowOpen('/dataCenter')"><img style="width:100%;" src='/image/screen.png'></div>`,
          position: 'bottom-right',
          duration: 0,
          offset: 20,
          onClose: () => {
            localStorage.setItem("closeScreen", 1)
          }
        });
        localStorage.removeItem("closeScreen")
      }
    },

    onPageEnterComplete() {
      // 使用 $nextTick 确保 DOM 更新完成
      this.$nextTick(() => {
        // 延迟一点时间，确保 transition 动画完全结束
        setTimeout(() => {
          // 滚动到页面顶部
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
          // 或者使用 window.scrollTo
          window.scrollTo(0, 0)
        }, 860) // 根据你的动画时长调整，比如 0.4s 动画 → 延迟 60ms
      })
    },
    handleClickBack() {
      // if (window.innerWidth < 1000) {
      //   this.menuDtawer = true;
      // }
      this.$router.push({
        path: "/h5HomePage",
      });
    },
    changeAniState(path) {
      this.menuDtawer = false;
      this.$router.push({
        path: path,
      });
    },
    setDefaultPath(val) {
      if (val) {
        let paths = val.split('/');
        if (paths.length > 2) {
          this.defaultPath = `/${paths[1]}`;
        } else {
          this.defaultPath = val;
        }
        // console.log(this.defaultPath, 222);
      }
    },
    splitArr(arr) {
      if (arr.length) {
        arr.map((item) => {
          if (item.navTitle) {
            this.subs.push({ navTitle: item.navTitle });
            if (item.childs) {
              this.splitArr(item.childs);
            }
          }
          if (item.path) {
            this.items.push({ path: item.path, title: item.title });
          }
        });
      }
    },
    filterPaths(val) {
      return this.allPaths.filter((item) => {
        return item.title.indexOf(val) > -1;
      });
    },
    getPaths(menu) {
      if (menu && menu.length) {
        menu.map((item) => {
          if (item.path) {
            this.allPaths.push(item);
          }
          if (item.childs && item.childs.length) {
            this.getPaths(item.childs);
          }
        });

      }
    },
    async getNewMessages() {
      let res = await this.$api.instance.getNewMessages({ count: 9999 });
      if (res.code == 0) {
        // this.doge = res.data.length;
        this.$store.commit('setDoge', res.data.length);
      }
    },
    indexChlid(pindex, cindex) {
      return `${pindex}-${cindex}`;
    },
  },
};
</script>
<style lang="less" scoped>
.Menu {
  height: calc(100% - 65px);
  width: 100%;
  background: #fff;
  margin: 0 auto;
  display: flex;
  box-shadow: 0px 4px 0px 4px #F0F1F2;
}

.menu-l {
  width: 250px;
  height: 100%;
  // background: #c4d8f1;
  background: #ffffff;
  overflow: auto;
  // padding-bottom: 32px;
  z-index: 999;
  box-sizing: border-box;
}

.menu-r {
  width: calc(100% - 250px);
  height: 100%;
  background: #F0F1F2;
  overflow-x: hidden;
  overflow-y: auto;
  transform-origin: 0px 0px;
}


/deep/.aside-right-enter-active,
/deep/.aside-right-leave-active {
  transition: all 0.8s ease-in-out;
  position: absolute;
  top: 0;
  width: 100%;
  box-sizing: border-box;
}

/deep/.aside-right-enter-active {
  left: -100%;
  animation: enter 0.8s forwards;
}

/deep/.aside-right-leave-active {
  animation: leave 0.8s forwards;
}

/deep/.aside-right-enter-to {
  transform: translate(100%, 0);
}

/deep/.aside-right-leave-to {
  transform: translate(100%, 0);
}

@keyframes enter {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes leave {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

@media screen and (min-width: 1000px) {
  .Menu {
    min-width: 1280px;
  }

  .menu-r-top {
    display: none;
  }

  /deep/.el-scrollbar {
    height: calc(100% - 48px);
  }

  .single-page {
    height: 100%;
    min-width: unset;

    .menu-l {
      display: none;
    }

    .menu-r {
      width: 100%;
    }
  }
}

/* 针对手机的样式 */
@media screen and (max-width: 1000px) {
  .Menu {
    // height: calc(100% - 70px);
    height: 100%;
  }

  .menu-l {
    display: none;
  }

  .menu-r {
    width: 100%;
    background: #fff;
  }

  .menu-r-top {
    font-size: 15px;
    box-shadow: 0 0 2px 2px #ccc;
    text-align: left;
    padding: 8px 8px;
    font-weight: bold;
    letter-spacing: 1.5px;
    z-index: 999;
    position: fixed;
    width: 100%;
    background: #fff;
  }

  .scrollbar {
    height: 100%;
    overflow: auto;
    // padding: 8px 0;
    box-sizing: border-box;
  }

  /deep/.el-scrollbar {
    height: calc(100% - 38px) !important;
    padding: 0 8px;
    box-sizing: border-box;
  }
}

.menuSearch {
  /deep/ .el-input__inner {
    margin-top: 8px;
    margin-bottom: 8px;
    height: 32px;
    line-height: 32px;
    width: 90%;
    background: #e4e5e5;
    color: #585858;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 1.2px;
    box-shadow: none;
    font-style: italic;
  }

  /deep/ input::-webkit-input-placeholder {
    /*WebKit browsers*/

    color: #585858;
    font-style: italic;
  }

  /deep/ input::-moz-input-placeholder {
    /*Mozilla Firefox*/

    color: #585858;
    font-style: italic;
  }

  /deep/ input::-ms-input-placeholder {
    /*Internet Explorer*/

    color: #585858;
    font-style: italic;
  }

  /deep/.el-input__suffix {
    right: 10px;
  }

  /deep/.el-input .el-input__clear {
    color: #585858;
  }
}
</style>
